import React from "react";
import PropTypes from "prop-types";

import Clipboard from "react-clipboard.js";
import Button from "material-ui/Button";

const OvAccountsInfoActions = props => {
  const { data, onClipboardEvent, sendToSheet, filterState } = props;

  const nameOnly = o => ({ ...o, name: o.name.split("|")[1] });

  const seriesToCsv = () => {
    if (data.length === 0) {
      return "";
    }
    const fields = [
      "name",
      "id",
      "instance_cost",
      "license_cost",
      "storage_cost",
      "cores",
      "minutes",
      "storage"
    ];
    const res = data.map(nameOnly).map(el => {
      return fields.map(f => el[f]).join(",");
    });
    res.unshift(fields.join(","));
    return res.join("\n");
  };

  const seriesToJson = () => {
    return JSON.stringify(data, (key, val) => {
      if (key === "name") {
        return val.split("|")[1];
      } else if (key === "self_link") {
        return;
      }
      return val;
    });
  };

  const onJsonSuccess = evt => {
    onClipboardEvent("JSON");
  };
  const onCsvSuccess = () => {
    onClipboardEvent("CSV");
  };

  const onClipError = evt => {
    onClipboardEvent("ERROR", evt);
  };

    function formatDate(timestamp) {
      const date = new Date(timestamp);
    
      const pad = (number) => number.toString().padStart(2, '0');
    
      const day = pad(date.getUTCDate());
      const month = pad(date.getUTCMonth() + 1);
      const year = date.getUTCFullYear().toString().slice(-2);
      const hours = pad(date.getUTCHours());
      const minutes = pad(date.getUTCMinutes());
    
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    }

    const onSendToSheet = evt => {
      const date = new Date();
      
      const exportedAt = formatDate(date);
      const sheetName = `Accounts_${exportedAt.replace(/:/g, '').replace(/ /g, '_')}`;
      const tableType = "Accounts";
      const startDate = formatDate(filterState.period.start);
      const endDate = formatDate(filterState.period.end);
  
      const tableInfo = [
        sheetName,
        tableType,
        exportedAt,
        startDate,
        endDate
      ]
      
 
  
      const res = data.map(el => {
        return [
          el.name.split("|")[1],
          el.cores,
          el.minutes,
          el.storage,
          el.instance_cost.toFixed(2),
          el.license_cost.toFixed(2),
          el.storage_cost.toFixed(2),
        ];
      });
  
      const last_row = res.length +3;
  
      res.push([
        "Total",
        `=SUM(E4:E${last_row})`,
        `=SUM(F4:F${last_row})`,
        `=SUM(G4:G${last_row})`,
        `=SUM(H4:H${last_row})`,
        `=SUM(I4:I${last_row})`,
        `=SUM(J4:J${last_row})`
      ]);
  
      res.forEach((row, index) => {
          row.push(`=SUM(H${index + 4}:J${index + 4})`);
      });
  
      sendToSheet("D4", res, tableInfo); 
    };

  return (
    <div>
      <Button color="primary">
        <Clipboard
          component="a"
          data-clipboard-text={seriesToJson()}
          onSuccess={onJsonSuccess}
          onError={onClipError}
        >
          JSON
        </Clipboard>
      </Button>

      <Button color="primary">
        <Clipboard
          component="a"
          data-clipboard-text={seriesToCsv()}
          onSuccess={onCsvSuccess}
          onError={onClipError}
        >
          CSV
        </Clipboard>
      </Button>
      <Button color="primary" onClick={onSendToSheet}>
        SHEET
      </Button>
    </div>
  );
};

OvAccountsInfoActions.propTypes = {
  data: PropTypes.array.isRequired,
  onClipboardEvent: PropTypes.func.isRequired
};

export default OvAccountsInfoActions;



// WEBPACK FOOTER //
// ./src/OvAccountsInfoActions.js